module.exports = __webpack_public_path__ + "media/assets/images/flags/cw-594a1ec8a48f6cce8c5bfc570ff89382.svg";